import React from 'react'
import Manager from '../../public/components/Manager'
import QualityFileDiv from './QualityFileDiv'
import QualityFileCatalogDiv from './QualityFileCataLogDiv'

Ext.require('Ext.Toast')

const config = ({ roles }) => {
	return {
		tabs: {
			受控: {
				buttons: [
					{ text: '添加...', handler: ({ showDetail, refreshPage }) => showDetail(props => <QualityFileDiv {...props} roles={roles} id={0} fatherID={0} onSave={refreshPage} />), cdt: () => roles.indexOf('超级用户') > -1 || roles.indexOf('文件管理员') > -1 },
				],
				columns: [
					{ _text: '文件编号', field: 'QualityFileNumber', minWidth: 250, search: true, },
					{ _text: '文件名称', field: 'QualityFileName', minWidth: 350, search: true, flex: 10, },
					{ _text: '版别', field: 'Version', minWidth: 150, },
					{ _text: '修改次数', field: 'ReviseTime', minWidth: 150, },
					{ _text: '文件状态', field: 'QualityFileStatus', minWidth: 150, filter: true, },
					{ _date: '起草日期', field: 'DraftOutDate', minWidth: 150, },


				],
				onDoubleTap: ({ showDetail, refreshPage }, data, record) => {
					showDetail(props => <QualityFileDiv {...props} roles={roles} id={data.id} fatherID={data.FatherID} onSave={refreshPage} />)
				},
				categories: {
					contextmenu: [
						{
							_button: '添加目录', icon: 'plus',
							hidden: () => roles.indexOf('权限管理员') == -1 && roles.indexOf('文件管理员') == -1 && roles.indexOf('质量负责人') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('文件管理', props => <QualityFileCatalogDiv {...props} id={0} fatherID={data.id} onSave={that.refresh} />)
							},
						},
						{
							_button: '属性', icon: 'info',
							hidden: data => data.depth == 1 || (roles.indexOf('权限管理员') == -1 && roles.indexOf('文件管理员') == -1 && roles.indexOf('质量负责人') == -1),
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('目录管理', props => <QualityFileCatalogDiv {...props} id={data.id} onSave={that.refresh} />)
							},
						},
					],
				},
			},
			已销毁: {
				columns: [
					{ _text: '文件编号', field: 'QualityFileNumber', minWidth: 250, search: true, },
					{ _text: '文件名称', field: 'QualityFileName', minWidth: 350, search: true, flex: 10, },
					{ _text: '版别', field: 'Version', minWidth: 150, },
					{ _text: '修改次数', field: 'ReviseTime', minWidth: 150, },
					{ _text: '文件状态', field: 'QualityFileStatus', minWidth: 150, filter: true, },
					{ _date: '起草日期', field: 'DraftOutDate', minWidth: 150, },


				],
				onDoubleTap: ({ showDetail, refreshPage }, data, record) => {
					showDetail(props => <QualityFileDiv {...props} roles={roles} id={data.id} fatherID={data.FatherID} onSave={refreshPage} />)
				},
				categories: {
					contextmenu: [
						{
							_button: '添加目录', icon: 'plus',
							hidden: () => roles.indexOf('权限管理员') == -1 && roles.indexOf('文件管理员') == -1 && roles.indexOf('质量负责人') == -1,
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('文件管理', props => <QualityFileCatalogDiv {...props} id={0} fatherID={data.id} onSave={that.refresh} />)
							},
						},
						{
							_button: '属性', icon: 'info',
							hidden: data => data.depth == 1 || (roles.indexOf('权限管理员') == -1 && roles.indexOf('文件管理员') == -1 && roles.indexOf('质量负责人') == -1),
							handler: (that, data, record, grid) => {
								Tyan.pubForm.showDialog('目录管理', props => <QualityFileCatalogDiv {...props} id={data.id} onSave={that.refresh} />)
							},
						},
					],
				},
			},
		}, 
	}
}

export default props => <Manager {...props} config={config} />